module.exports = __webpack_public_path__ + "img/37.75d30a64.png";